// bm-design-system: finding group primitive
import * as React from "react";
import { cva, type VariantProps } from "class-variance-authority";
import { cn } from "@/lib/utils";

// CLAUDE.md forbids text utilities on bare semantic elements (the base layer
// already styles h1-h6). An eyebrow-style section label needs a smaller,
// uppercase, tone-colored treatment that has nothing to do with the base <h2>
// styling, so those utilities live on this inner <span> instead of the <h2>
// itself — the heading stays completely bare.
const findingGroupEyebrowVariants = cva("text-sm font-semibold uppercase tracking-wider", {
  variants: {
    status: {
      fail: "text-danger-display",
      warn: "text-signal-display",
      pass: "text-success-display",
    },
  },
  defaultVariants: {
    status: "pass",
  },
});

export interface FindingGroupProps
  extends Omit<React.HTMLAttributes<HTMLDivElement>, "title">,
    VariantProps<typeof findingGroupEyebrowVariants> {
  title: React.ReactNode;
}

const FindingGroup = React.forwardRef<HTMLDivElement, FindingGroupProps>(
  ({ className, status, title, children, ...props }, ref) => {
    return (
      <div ref={ref} className={cn("mt-10", className)} {...props}>
        <h2>
          <span className={findingGroupEyebrowVariants({ status })}>{title}</span>
        </h2>
        <div className="mt-4 space-y-4">{children}</div>
      </div>
    );
  },
);
FindingGroup.displayName = "FindingGroup";

export { FindingGroup, findingGroupEyebrowVariants };
